import { createStore } from '@stencil/store';
import { PersonDoc } from 'common';
import { TeamDoc } from '../service/PeopleService';

export interface PeopleStoreState {
  loading: boolean;
  people: PersonDoc[];
  teams: TeamDoc[];
  projectId: string | null;
}

const initialStoreState: PeopleStoreState = {
  loading: true,
  people: [],
  teams: [],
  projectId: null,
};

export const { state: peopleState, onChange: peopleStoreOnChange } = createStore<PeopleStoreState>(initialStoreState);

export const setPeopleStoreLoading = (loading: boolean) => {
  peopleState.loading = loading;
};

// Helper functions to update store
export const setPeopleStorePeople = (people: PersonDoc[]) => {
  peopleState.people = people;
};

export const setPeopleStoreTeams = (teams: TeamDoc[]) => {
  peopleState.teams = teams;
};

export const setPeopleStoreProjectId = (projectId: string | null) => {
  peopleState.projectId = projectId;
};

export const resetPeopleStore = () => {
  peopleState.people = [];
  peopleState.teams = [];
  peopleState.projectId = null;
};
